import { render, staticRenderFns } from "./ImportNewFrSite.vue?vue&type=template&id=65ca9cb2"
import script from "./ImportNewFrSite.vue?vue&type=script&lang=js"
export * from "./ImportNewFrSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports